import { Collapse, Grid, MenuItem, TextField } from '@mui/material';
import React from 'react';
import { CustomeTextField } from '../../../generic/CustomeTextField';
import { staticArrayAsProxy } from '../../../Interfaces/IAsProxy';
import { ILegalTransactionRelationshipDataSignatureCertification } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipMemberData';
import { ISignatureCertificationLegalClient } from '../../../Interfaces/ISignatureCertificationLegalClient';
import { staticTypeOfIdentificationArray } from '../../../Interfaces/ITypeOfIdentification';

interface ISignatureCertificationLegalClientRelationshipDataProps {
  signatureCertificationData: ILegalTransactionRelationshipDataSignatureCertification;
  setSignatureCertificationData: (
    signatureCertificationData: ISignatureCertificationLegalClient['signatureCertificationData']
  ) => void;
}

export const SignatureCertificationLegalClientRelationshipData: React.FC<
  ISignatureCertificationLegalClientRelationshipDataProps
> = ({ signatureCertificationData, setSignatureCertificationData }) => {
  const isFreeTextAsProxy = staticArrayAsProxy.find(
    x =>
      signatureCertificationData.asProxy &&
      x.idAsProxy === signatureCertificationData.idAsProxy
  )?.allowFreeText;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            select
            fullWidth
            label='Ausweisdokument'
            size='small'
            value={signatureCertificationData.idTypeOfDocument}
            required
            onChange={event =>
              setSignatureCertificationData({
                ...signatureCertificationData,
                idTypeOfDocument: Number(event.target.value),
              })
            }
          >
            {staticTypeOfIdentificationArray.map(doc => (
              <MenuItem
                key={`typeofdoc-${doc.idTypeOfDocument}`}
                value={doc.idTypeOfDocument}
              >
                {doc.TypeOfDocument}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <Collapse
            in={
              staticTypeOfIdentificationArray.find(
                x =>
                  x.idTypeOfDocument ===
                  signatureCertificationData.idTypeOfDocument
              )?.allowFreeText
            }
          >
            <TextField
              fullWidth
              label='Ergänzende Informationen zum Ausweisdokument'
              size='small'
              value={
                signatureCertificationData.textTypeOfDocument === null
                  ? ''
                  : signatureCertificationData.textTypeOfDocument
              }
              onChange={event =>
                setSignatureCertificationData({
                  ...signatureCertificationData,
                  textTypeOfDocument: event.target.value,
                })
              }
            />
          </Collapse>
        </Grid>
        <Grid item xs={6}>
          <CustomeTextField
            label='Als Vetretung von Dritten'
            attr='asProxy'
            object={signatureCertificationData}
            // TODO:
            setObject={(
              upObj: ISignatureCertificationLegalClient['signatureCertificationData']
            ) => setSignatureCertificationData(upObj)}
            type='boolean'
          />
        </Grid>
        <Grid item xs={6}>
          <Collapse in={signatureCertificationData.asProxy === true}>
            <CustomeTextField
              attr='idAsProxy'
              label='Vertretungsart'
              object={signatureCertificationData}
              setObject={(
                upObj: ISignatureCertificationLegalClient['signatureCertificationData']
              ) => {
                console.log('upObj', upObj);
                setSignatureCertificationData({
                  ...upObj,
                  idAsProxy: Number(upObj.idAsProxy),
                });
              }}
              type='select'
            >
              {staticArrayAsProxy.map(asProxy => (
                <MenuItem
                  key={`asproxy-${asProxy.idAsProxy}`}
                  value={asProxy.idAsProxy}
                >
                  {asProxy.typeAsProxy}
                </MenuItem>
              ))}
            </CustomeTextField>
          </Collapse>
        </Grid>
        <Grid item xs={12}>
          <Collapse in={isFreeTextAsProxy}>
            <CustomeTextField
              label='Ergänzende Informationen zur Vertretung'
              attr='textAsProxy'
              object={signatureCertificationData}
              setObject={(
                upObj: ISignatureCertificationLegalClient['signatureCertificationData']
              ) => setSignatureCertificationData(upObj)}
              type='string'
              rows={2}
              null
              required={isFreeTextAsProxy}
            />
          </Collapse>
        </Grid>
      </Grid>
    </>
  );
};
